/**
 * @name UserTypes ActionTypes
 * @memberof module:common/actions
 * @type {ReduxAction}
 * @return {Object} User Actions Types
 */
export const GET_USER_SELECTED_INFO = 'GET_USER_SELECTED_INFO';
export const SET_USER_SELECTED_INFO = 'SET_USER_SELECTED_INFO';
export const SET_OTHER_PERMISSIONS = 'SET_OTHER_PERMISSIONS';
